import { Container, Grid, Typography } from '@material-ui/core'
import React from 'react'
import { useHistory } from 'react-router-dom'

import generateTicketStyles from './css/generateTicketStyles'
import GenerateTicketCard from '../../components/cards/GenerateTicketCard/GenerateTicketCard'
import { ReactComponent as LogoRipleyWhite } from '../../assets/svg/logoRipleyWhite.svg'
import TiendaFisica from '../../assets/svg/tiendaFisica.svg'
import TiendaOnline from '../../assets/svg/tiendaOnline.svg'

const GenerateTicket = () => {
  const classes = generateTicketStyles()
  const history = useHistory()

  return (
    <div className={classes.root}>
      <Container maxWidth="md" className={classes.container}>
        <LogoRipleyWhite />
        <Typography align="center" variant="h5" className={classes.title}>
          Ticket de regalo
        </Typography>
        <Typography align="center" variant="subtitle2" className={classes.subTitle}>
          Solicita un cambio o devolución con tu boleta de compra Ripley
        </Typography>
        <Typography align="center" variant="h6" className={classes.subTitle2}>
          ¿Dónde realizaste tu compra?
        </Typography>
        <Grid container spacing={2} alignItems="center" justify="center">
          <Grid item>
            <GenerateTicketCard
              imgSrc={TiendaFisica}
              title="Tienda física"
              subtitle="Compra en tienda o mall"
              onCardClick={() => history.push('compra-tienda')}
            />
          </Grid>
          <Grid item>
            <GenerateTicketCard
              imgSrc={TiendaOnline}
              title="Por Ripley.com"
              subtitle="Compra online"
              onCardClick={() => history.push('compra-online')}
            />
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default GenerateTicket
